<app-permit-common-details [permit]="permit" membersLabel="Research team"></app-permit-common-details>

<!-- The applicant said they have no approved agreement (decision #7). It never stopped
     them applying, so this is the only thing that tells the reviewer to expect one to be
     negotiated before the permit can be issued. Only shown for an explicit No: null is a
     permit that predates the question, and Yes needs no warning. -->
@if (permit.research?.declaredHasAgreement === false) {
    <div class="alert alert-warning d-flex align-items-start" role="alert">
        <i class="fa fa-file-signature me-3 mt-1"></i>
        <div>
            <strong>No approved research agreement declared</strong>
            <p class="mb-0 mt-1">
                The applicant said they do not yet have a signed Research Access Agreement. A research permit cannot be issued until one is in place - this
                application is theirs to progress, not a reason to refuse it on its own.
            </p>
        </div>
    </div>
}

@if (permit.research; as r) {
    <dl class="row mb-0 mt-2">
        <dt class="col-sm-4">Organisation</dt>
        <dd class="col-sm-8">{{ r.organisation || '-' }}</dd>

        <dt class="col-sm-4">Project</dt>
        <dd class="col-sm-8">{{ r.projectTitle || '-' }}</dd>

        <dt class="col-sm-4">Approved agreement</dt>
        <dd class="col-sm-8">
            @switch (r.declaredHasAgreement) {
                @case (true) {
                    <span class="text-success">Applicant says yes</span>
                }
                @case (false) {
                    <span class="text-warning-emphasis">Applicant says no</span>
                }
                @default {
                    <span class="text-muted">not asked</span>
                }
            }
        </dd>

        <!-- The team is shown by app-permit-common-details above (labelled "Research
             team"), the one place every type lists its people. Ethics / WWC / police
             uploads were removed from the application (TLC, 28 Sep) - those documents are
             handled off-portal with the Research Access Agreement. -->
    </dl>
}
